"use client";

import ServiceHeader from "@/views/service-center/components/service-header";
import ServiceMain from "@/views/service-center/components/service-main";
import SupportBlock from "@/components/entities/support-block";
import { useServiceCenterPageData } from "@/views/service-center/hooks/useServiceCenterPageData";
import ServiceTerms from "./components/service-terms";
import { useStrictLocale } from "@/hooks/locale/useStrictLocale/useStrictLocale";
import ServiceContacts from "./components/service-contacts";
import { Locales } from "@/hooks/locale/useChangeLocale/types";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const ServiceCenterView = () => {
  const locale = useStrictLocale();

  const {
    serviceCenterPage: { serviceCenterPage, loading },
  } = useServiceCenterPageData();

  if (!serviceCenterPage || loading) return null;

  return (
    <>
      <ServiceHeader video={serviceCenterPage.page.video} />
      <Container className={S.mainWrapper}>
        <div className={S.contentWrapper}>
          {locale === Locales.UK && <ServiceContacts />}
          <ServiceMain
            title={serviceCenterPage.page.title}
            description={serviceCenterPage.page.description}
            categories={serviceCenterPage.categories}
          />{" "}
          {locale === Locales.UK && <ServiceTerms />}
        </div>
        <SupportBlock info={serviceCenterPage.block} />
      </Container>
    </>
  );
};

export default ServiceCenterView;
